import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, h = { key: 1 }, k = { key: 2 }, w = { key: 3 }, A = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconArrowLeft"
}, L = /* @__PURE__ */ i({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = f(s);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", H, l[0] || (l[0] = [
        n("path", { d: "M228,128a12,12,0,0,1-12,12H69l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L69,116H216A12,12,0,0,1,228,128Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", h, l[1] || (l[1] = [
        n("path", {
          d: "M112,56V200L40,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M216,120H120V56a8,8,0,0,0-13.66-5.66l-72,72a8,8,0,0,0,0,11.32l72,72A8,8,0,0,0,120,200V136h96a8,8,0,0,0,0-16ZM104,180.69,51.31,128,104,75.31Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", k, l[2] || (l[2] = [
        n("path", { d: "M224,128a8,8,0,0,1-8,8H120v64a8,8,0,0,1-13.66,5.66l-72-72a8,8,0,0,1,0-11.32l72-72A8,8,0,0,1,120,56v64h96A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", w, l[3] || (l[3] = [
        n("path", { d: "M222,128a6,6,0,0,1-6,6H54.49l61.75,61.76a6,6,0,1,1-8.48,8.48l-72-72a6,6,0,0,1,0-8.48l72-72a6,6,0,0,1,8.48,8.48L54.49,122H216A6,6,0,0,1,222,128Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", A, l[4] || (l[4] = [
        n("path", { d: "M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", M, l[5] || (l[5] = [
        n("path", { d: "M220,128a4,4,0,0,1-4,4H49.66l65.17,65.17a4,4,0,0,1-5.66,5.66l-72-72a4,4,0,0,1,0-5.66l72-72a4,4,0,0,1,5.66,5.66L49.66,124H216A4,4,0,0,1,220,128Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
